import type { Vehicle, Shipment, TelemetryReading, Alert, Stats, VehicleRoute, RoutePoint } from '../api';

let vehicles: Vehicle[] = [];
let shipments: Shipment[] = [];
let telemetryData: TelemetryReading[] = [];
let alerts: Alert[] = [];
let nextAlertId = 100;
let nextTelemetryId = 100000;

type AlertListener = (alert: Alert) => void;
const alertListeners: AlertListener[] = [];
export function onAlert(fn: AlertListener) { alertListeners.push(fn); }
export function offAlert(fn: AlertListener) {
  const idx = alertListeners.indexOf(fn);
  if (idx >= 0) alertListeners.splice(idx, 1);
}

export const routes: Record<string, RoutePoint[]> = {
  'TR-01': [{lat:41.01,lng:28.98},{lat:42.70,lng:23.32},{lat:44.79,lng:20.45},{lat:47.50,lng:19.04},{lat:48.21,lng:16.37},{lat:48.14,lng:11.58}],
  'TR-02': [{lat:39.93,lng:32.86},{lat:41.01,lng:28.98},{lat:42.70,lng:23.32},{lat:44.79,lng:20.45},{lat:47.50,lng:19.04},{lat:48.21,lng:16.37}],
  'TR-03': [{lat:38.42,lng:27.14},{lat:41.01,lng:28.98},{lat:42.70,lng:23.32},{lat:44.79,lng:20.45},{lat:45.82,lng:15.98},{lat:46.06,lng:14.51},{lat:45.46,lng:9.19}],
  'TR-05': [{lat:36.90,lng:30.71},{lat:39.93,lng:32.86},{lat:41.01,lng:28.98},{lat:42.70,lng:23.32},{lat:44.79,lng:20.45},{lat:47.50,lng:19.04},{lat:48.21,lng:16.37},{lat:50.11,lng:8.68},{lat:51.92,lng:4.48}],
  'TR-06': [{lat:36.81,lng:34.64},{lat:39.93,lng:32.86},{lat:41.01,lng:28.98},{lat:42.70,lng:23.32},{lat:44.79,lng:20.45},{lat:47.50,lng:19.04},{lat:48.21,lng:16.37},{lat:50.08,lng:14.44},{lat:51.05,lng:13.74},{lat:53.55,lng:9.99}],
  'TR-08': [{lat:39.93,lng:32.86},{lat:41.01,lng:28.98},{lat:43.23,lng:27.91},{lat:44.43,lng:26.10}],
};

const cityCoords: Record<string, RoutePoint> = {
  'Istanbul': {lat:41.01,lng:28.98},
  'Ankara': {lat:39.93,lng:32.86},
  'Izmir': {lat:38.42,lng:27.14},
  'Antalya': {lat:36.90,lng:30.71},
  'Bursa': {lat:40.18,lng:29.06},
  'Mersin': {lat:36.81,lng:34.64},
  'Munich': {lat:48.14,lng:11.58},
  'Hamburg': {lat:53.55,lng:9.99},
  'Milan': {lat:45.46,lng:9.19},
  'Vienna': {lat:48.21,lng:16.37},
  'Rotterdam': {lat:51.92,lng:4.48},
  'Athens': {lat:37.97,lng:23.72},
  'Sofia': {lat:42.70,lng:23.32},
  'Bucharest': {lat:44.43,lng:26.10},
  'Belgrade': {lat:44.79,lng:20.45},
  'Ljubljana': {lat:46.06,lng:14.51},
  'Budapest': {lat:47.50,lng:19.04},
  'Prague': {lat:50.08,lng:14.44},
  'Mersin Port': {lat:36.81,lng:34.64},
  'Istanbul Port': {lat:41.01,lng:28.98},
};

export function seed() {
  const now = Date.now();
  const H = 3600000;
  const M = 60000;

  vehicles = [
    {id:'TR-01',name:'Arctic Runner',type:'reefer_truck',home_base:'Istanbul',current_driver:'Mehmet Yilmaz',status:'active',latitude:44.78,longitude:20.45,heading:0,speed:0,total_km:142850,uptime_hours:8640},
    {id:'TR-02',name:'Frost Express',type:'reefer_truck',home_base:'Ankara',current_driver:'Ali Demir',status:'active',latitude:43.85,longitude:22.40,heading:0,speed:0,total_km:98200,uptime_hours:6720},
    {id:'TR-03',name:'CoolHaul',type:'reefer_truck',home_base:'Izmir',current_driver:'Kemal Ozturk',status:'active',latitude:42.70,longitude:23.32,heading:0,speed:0,total_km:115400,uptime_hours:7200},
    {id:'TR-04',name:'IceWay',type:'reefer_truck',home_base:'Antalya',current_driver:'Emre Kaya',status:'idle',latitude:36.90,longitude:30.71,heading:0,speed:0,total_km:67300,uptime_hours:4320},
    {id:'TR-05',name:'PolarShift',type:'reefer_truck',home_base:'Bursa',current_driver:'Can Aksoy',status:'active',latitude:46.06,longitude:14.51,heading:0,speed:0,total_km:183600,uptime_hours:10080},
    {id:'TR-06',name:'GlacierLine',type:'reefer_truck',home_base:'Mersin',current_driver:'Hasan Celik',status:'active',latitude:47.50,longitude:19.04,heading:0,speed:0,total_km:124700,uptime_hours:7920},
    {id:'TR-07',name:'SnowTrail',type:'reefer_truck',home_base:'Istanbul',current_driver:'',status:'maintenance',latitude:41.01,longitude:28.98,heading:0,speed:0,total_km:201300,uptime_hours:12600},
    {id:'TR-08',name:'FreezeWay',type:'reefer_truck',home_base:'Ankara',current_driver:'Burak Sahin',status:'active',latitude:44.43,longitude:26.10,heading:0,speed:0,total_km:89100,uptime_hours:5040},
    {id:'SC-01',name:'Container Alpha',type:'sea_container',home_base:'Mersin Port',current_driver:'Yusuf Erdogan',status:'active',latitude:36.81,longitude:34.64,heading:0,speed:0,total_km:31200,uptime_hours:2160},
    {id:'SC-02',name:'Container Beta',type:'sea_container',home_base:'Istanbul Port',current_driver:'Omer Arslan',status:'active',latitude:41.01,longitude:28.98,heading:0,speed:0,total_km:45600,uptime_hours:3360},
  ];

  const hMin = 40.0;
  const hMax = 65.0;
  const shipmentDefs = [
    {id:'SH-2401',vid:'TR-01',origin:'Istanbul',dest:'Munich',cargo:'Pharmaceuticals',desc:'Insulin pens, 2400 units',status:'in_transit',tMin:-2,tMax:8,hMin:hMin,hMax:hMax,pOff:-18*H,eOff:12*H,cTemp:4.2,cHum:52.0},
    {id:'SH-2402',vid:'TR-06',origin:'Mersin',dest:'Hamburg',cargo:'Fresh Produce',desc:'Citrus fruits, 18 pallets',status:'in_transit',tMin:2,tMax:6,hMin:null,hMax:null,pOff:-24*H,eOff:18*H,cTemp:3.8,cHum:55.0},
    {id:'SH-2403',vid:'TR-03',origin:'Izmir',dest:'Milan',cargo:'Frozen Seafood',desc:'Sea bass fillets, 12 tons',status:'in_transit',tMin:-25,tMax:-18,hMin:null,hMax:null,pOff:-14*H,eOff:20*H,cTemp:-21.3,cHum:0},
    {id:'SH-2404',vid:'TR-02',origin:'Ankara',dest:'Vienna',cargo:'Dairy Products',desc:'Aged cheese, 8 pallets',status:'in_transit',tMin:2,tMax:4,hMin:hMin,hMax:hMax,pOff:-20*H,eOff:8*H,cTemp:3.1,cHum:48.0},
    {id:'SH-2405',vid:'TR-05',origin:'Antalya',dest:'Rotterdam',cargo:'Vaccines',desc:'COVID-19 vaccines, 50k doses',status:'in_transit',tMin:2,tMax:8,hMin:null,hMax:null,pOff:-30*H,eOff:6*H,cTemp:5.6,cHum:0},
    {id:'SH-2406',vid:'SC-01',origin:'Mersin',dest:'Athens',cargo:'Fresh Produce',desc:'Pomegranates, 20 pallets',status:'loading',tMin:1,tMax:5,hMin:null,hMax:null,pOff:-1*H,eOff:48*H,cTemp:3.0,cHum:0},
    {id:'SH-2407',vid:'TR-04',origin:'Bursa',dest:'Sofia',cargo:'Dairy Products',desc:'Yogurt, 6 pallets',status:'scheduled',tMin:2,tMax:6,hMin:hMin,hMax:hMax,pOff:4*H,eOff:28*H,cTemp:0,cHum:0},
    {id:'SH-2408',vid:'TR-08',origin:'Ankara',dest:'Bucharest',cargo:'Pharmaceuticals',desc:'Blood plasma, 180 units',status:'in_transit',tMin:2,tMax:8,hMin:null,hMax:null,pOff:-10*H,eOff:14*H,cTemp:9.2,cHum:0},
    {id:'SH-2409',vid:'SC-02',origin:'Istanbul',dest:'Belgrade',cargo:'Frozen Meat',desc:'Lamb carcasses, 15 tons',status:'delivered',tMin:-20,tMax:-15,hMin:null,hMax:null,pOff:-72*H,eOff:-2*H,cTemp:-17.5,cHum:0},
    {id:'SH-2410',vid:'TR-01',origin:'Munich',dest:'Istanbul',cargo:'Pharmaceuticals',desc:'Monoclonal antibodies',status:'scheduled',tMin:2,tMax:8,hMin:hMin,hMax:hMax,pOff:24*H,eOff:60*H,cTemp:0,cHum:0},
  ];

  shipments = shipmentDefs.map(s => ({
    id: s.id,
    vehicle_id: s.vid,
    origin: s.origin,
    destination: s.dest,
    cargo_type: s.cargo,
    cargo_description: s.desc,
    temp_min: s.tMin,
    temp_max: s.tMax,
    humidity_min: s.hMin,
    humidity_max: s.hMax,
    pickup_time: new Date(now + s.pOff).toISOString(),
    eta: new Date(now + s.eOff).toISOString(),
    actual_delivery: s.status === 'delivered' ? new Date(now - 2 * H).toISOString() : null,
    status: s.status,
    current_temp: s.cTemp !== 0 ? s.cTemp : null,
    current_humidity: s.cHum !== 0 ? s.cHum : null,
  }));

  const alertDefs = [
    {vid:'TR-08',sid:'SH-2408',type:'temp_excursion',sev:'high',desc:'Temperature drift detected: 9.2°C exceeds max 8°C threshold',resolved:false,ago:12},
    {vid:'TR-01',sid:'SH-2401',type:'door_open',sev:'medium',desc:'Door opened during transit — unscheduled stop near Belgrade',resolved:true,ago:45},
    {vid:'TR-03',sid:'SH-2403',type:'gps_lost',sev:'critical',desc:'GPS signal lost — last known position: Sofia, Bulgaria',resolved:false,ago:4},
    {vid:'TR-01',sid:'SH-2401',type:'route_deviation',sev:'low',desc:'Minor route deviation detected near Serbian border',resolved:true,ago:120},
    {vid:'TR-06',sid:'SH-2402',type:'temp_excursion',sev:'high',desc:'Brief temperature spike to 7.1°C during loading zone transit',resolved:false,ago:30},
    {vid:'SC-02',sid:'SH-2409',type:'delivery_arrival',sev:'low',desc:'Shipment arrived at destination — Belgrade cold storage',resolved:true,ago:60},
    {vid:'TR-05',sid:'SH-2405',type:'door_open',sev:'medium',desc:'Unscheduled door opening detected near Ljubljana checkpoint',resolved:false,ago:20},
  ];

  let alertId = 1;
  alerts = alertDefs.map(a => {
    const v = vehicles.find(v => v.id === a.vid);
    const s = shipments.find(s => s.id === a.sid);
    return {
      id: alertId++,
      vehicle_id: a.vid,
      shipment_id: a.sid,
      event_type: a.type,
      severity: a.sev,
      description: a.desc,
      resolved: a.resolved,
      resolved_at: a.resolved ? new Date(now - (a.ago - 5) * M).toISOString() : null,
      created_at: new Date(now - a.ago * M).toISOString(),
      vehicle_name: v?.name || '',
      shipment_destination: s?.destination || '',
    };
  });
  nextAlertId = alertId;

  telemetryData = [];
  let telId = 1;
  const numReadings = 288;

  for (const s of shipmentDefs) {
    if (s.status !== 'in_transit' && s.status !== 'delivered') continue;
    const baseTemp = s.cTemp;
    const baseHum = s.cHum || 50;
    let driftTemp = baseTemp;
    let driftHum = baseHum;

    for (let i = 0; i < numReadings; i++) {
      const ts = new Date(now - (numReadings - i) * 5 * M).toISOString();
      driftTemp += (Math.random() - 0.5) * 0.3;
      if (driftTemp > baseTemp + 3) driftTemp = baseTemp + 2.5;
      if (driftTemp < baseTemp - 3) driftTemp = baseTemp - 2.5;
      let temp = driftTemp + (Math.random() - 0.5) * 0.5;
      if (i === 80 || i === 81 || i === 82) temp = baseTemp + 3.5 + Math.random() * 1.5;
      if (i === 200 || i === 201) temp = baseTemp - 2.5 - Math.random() * 0.8;
      driftHum += (Math.random() - 0.5) * 1.5;
      if (driftHum > baseHum + 8) driftHum = baseHum + 6;
      if (driftHum < baseHum - 8) driftHum = baseHum - 6;
      const hum = driftHum + (Math.random() - 0.5) * 2;
      const speed = 60 + Math.random() * 30;
      const doorOpen = i === 80 || i === 200;

      telemetryData.push({
        id: telId++,
        vehicle_id: s.vid,
        shipment_id: s.id,
        timestamp: ts,
        latitude: 0,
        longitude: 0,
        temperature: temp,
        humidity: hum,
        door_open: doorOpen,
        speed,
      });
    }
  }
  nextTelemetryId = telId;
}

export function getVehicles(): Vehicle[] {
  return [...vehicles].sort((a, b) => a.id.localeCompare(b.id));
}

export function getVehicle(id: string): Vehicle | undefined {
  return vehicles.find(v => v.id === id);
}

export function getVehicleShipments(vehicleId: string): Shipment[] {
  return shipments.filter(s => s.vehicle_id === vehicleId).reverse();
}

export function getVehicleAlerts(vehicleId: string): Alert[] {
  return alerts
    .filter(a => a.vehicle_id === vehicleId)
    .sort((a, b) => b.created_at.localeCompare(a.created_at))
    .slice(0, 20);
}

export function getVehicleRoute(vehicleId: string): VehicleRoute {
  const waypoints = routes[vehicleId];
  if (waypoints && waypoints.length >= 2) return { waypoints };

  const active = shipments.find(
    s => s.vehicle_id === vehicleId &&
      (s.status === 'in_transit' || s.status === 'loading' || s.status === 'scheduled')
  );
  if (active) {
    const orig = cityCoords[active.origin];
    const dest = cityCoords[active.destination];
    if (orig && dest) {
      const mid: RoutePoint = { lat: (orig.lat + dest.lat) / 2, lng: (orig.lng + dest.lng) / 2 };
      return { waypoints: [orig, mid, dest] };
    }
  }

  const v = vehicles.find(v => v.id === vehicleId);
  if (v && v.latitude !== 0 && v.longitude !== 0) {
    const home = cityCoords[v.home_base];
    if (home) {
      const cur: RoutePoint = { lat: v.latitude, lng: v.longitude };
      const mid: RoutePoint = { lat: (home.lat + cur.lat) / 2, lng: (home.lng + cur.lng) / 2 };
      return { waypoints: [home, mid, cur] };
    }
  }

  return { waypoints: [] };
}

export function getShipments(status?: string): Shipment[] {
  let result = [...shipments];
  if (status && status !== '' && status !== 'all') {
    result = result.filter(s => s.status === status);
  }
  return result.map(s => {
    const v = vehicles.find(v => v.id === s.vehicle_id);
    return { ...s, vehicle_name: v?.name || '' };
  }).reverse();
}

export function getShipment(id: string): Shipment | undefined {
  const s = shipments.find(s => s.id === id);
  if (!s) return undefined;
  const v = vehicles.find(v => v.id === s.vehicle_id);
  return { ...s, vehicle_name: v?.name || '' };
}

function parseUTC(s: string): number {
  if (s.includes('T') || s.includes('Z')) return new Date(s).getTime();
  return new Date(s.replace(' ', 'T') + 'Z').getTime();
}

export function getShipmentTelemetry(shipmentId: string, from?: string, to?: string): TelemetryReading[] {
  let result = telemetryData.filter(t => t.shipment_id === shipmentId);
  if (from) {
    const fromMs = parseUTC(from);
    result = result.filter(t => new Date(t.timestamp).getTime() >= fromMs);
  }
  if (to) {
    const toMs = parseUTC(to);
    result = result.filter(t => new Date(t.timestamp).getTime() <= toMs);
  }
  return result.sort((a, b) => a.timestamp.localeCompare(b.timestamp));
}

export function getAlerts(resolved?: string): Alert[] {
  let result = [...alerts];
  if (resolved === 'true') result = result.filter(a => a.resolved);
  else if (resolved === 'false') result = result.filter(a => !a.resolved);
  return result.sort((a, b) => b.created_at.localeCompare(a.created_at));
}

export function resolveAlert(id: number): void {
  const alert = alerts.find(a => a.id === id);
  if (alert) {
    alert.resolved = true;
    alert.resolved_at = new Date().toISOString();
  }
}

export function getStats(): Stats {
  const inTransitShipments = shipments.filter(s => s.status === 'in_transit' && s.current_temp != null);
  const avgTemp = inTransitShipments.length > 0
    ? inTransitShipments.reduce((sum, s) => sum + (s.current_temp || 0), 0) / inTransitShipments.length
    : 0;

  return {
    total_vehicles: vehicles.length,
    active_vehicles: vehicles.filter(v => v.status === 'active').length,
    in_transit: shipments.filter(s => s.status === 'in_transit').length,
    active_alerts: alerts.filter(a => !a.resolved).length,
    delivered_today: shipments.filter(s =>
      s.status === 'delivered' && s.actual_delivery &&
      Date.now() - new Date(s.actual_delivery).getTime() < 24 * 3600000
    ).length,
    avg_temp: avgTemp,
  };
}

export function createVehicle(v: Partial<Vehicle>): Vehicle {
  if (vehicles.find(x => x.id === v.id)) throw new Error(`vehicle ${v.id} already exists`);
  const vehicle: Vehicle = {
    id: v.id || '', name: v.name || '', type: v.type || 'reefer_truck',
    home_base: v.home_base || '', current_driver: v.current_driver || '',
    status: v.status || 'idle', latitude: v.latitude || 0, longitude: v.longitude || 0,
    heading: 0, speed: 0, total_km: 0, uptime_hours: 0,
  };
  vehicles.push(vehicle);
  return vehicle;
}

export function createShipment(s: Partial<Shipment>): Shipment {
  const id = s.id || `SH-${Date.now() % 100000}`;
  if (shipments.find(x => x.id === id)) throw new Error(`shipment ${id} already exists`);
  const shipment: Shipment = {
    id, vehicle_id: s.vehicle_id || '', origin: s.origin || '', destination: s.destination || '',
    cargo_type: s.cargo_type || '', cargo_description: s.cargo_description || '',
    temp_min: s.temp_min || 0, temp_max: s.temp_max || 0,
    humidity_min: s.humidity_min ?? null, humidity_max: s.humidity_max ?? null,
    pickup_time: s.pickup_time || new Date().toISOString(),
    eta: s.eta || new Date(Date.now() + 24 * 3600000).toISOString(),
    actual_delivery: null, status: 'scheduled', current_temp: null, current_humidity: null,
  };
  shipments.push(shipment);
  return shipment;
}

export function updateVehiclePosition(id: string, lat: number, lng: number, heading: number, speed: number, kmDelta: number) {
  const v = vehicles.find(v => v.id === id);
  if (v) { v.latitude = lat; v.longitude = lng; v.heading = heading; v.speed = speed; v.total_km += kmDelta; }
}

export function updateShipmentTemp(id: string, temp: number, humidity: number) {
  const s = shipments.find(s => s.id === id);
  if (s) { s.current_temp = temp; s.current_humidity = humidity; }
}

export function insertTelemetry(reading: Omit<TelemetryReading, 'id'>) {
  telemetryData.push({ ...reading, id: nextTelemetryId++ });
}

export function insertAlert(vehicleId: string, shipmentId: string, eventType: string, severity: string, description: string): Alert {
  const v = vehicles.find(v => v.id === vehicleId);
  const s = shipments.find(s => s.id === shipmentId);
  const alert: Alert = {
    id: nextAlertId++, vehicle_id: vehicleId, shipment_id: shipmentId,
    event_type: eventType, severity, description,
    resolved: false, resolved_at: null, created_at: new Date().toISOString(),
    vehicle_name: v?.name || '', shipment_destination: s?.destination || '',
  };
  alerts.push(alert);
  alertListeners.forEach(fn => fn(alert));
  return alert;
}

export function getShipmentThresholds(): Array<{ shipmentId: string; vehicleId: string; tempMin: number; tempMax: number }> {
  return shipments
    .filter(s => s.status === 'in_transit')
    .map(s => ({ shipmentId: s.id, vehicleId: s.vehicle_id, tempMin: s.temp_min, tempMax: s.temp_max }));
}
